var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-form-fancy-select-input',_vm._g(_vm._b({attrs:{"multiple":true,"options":_vm.options,"value":_vm.value}},'core-form-fancy-select-input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }